import RequestService from '../services/request.service'
import SessionService from '../core/session'
// import { message } from 'antd'

const sessionService = SessionService.Instance()

export default abstract class BaseAction {
  FetchSimpleList(requestUrl: string, condition?: any): Promise<any> {
    const queryCondition = condition || {}

    const httpClient = RequestService.Instance().getClient(
      sessionService.getToken()
    )
    return httpClient
      .get(requestUrl, { params: queryCondition })
      .then((response: any) => {
        const responseData = response.data
        if (responseData.status) {
          throw new Error(responseData['msg'])
        }

        return responseData.data
      })
      // .catch((err: Error) => {
      //   message.warning(err.message)
      // })
  }

  FetchSimpleData(requestUrl: string, condition?: any): Promise<any> {
    const queryCondition = condition || {}

    const httpClient = RequestService.Instance().getClient(
      sessionService.getToken()
    )
    return httpClient
      .get(requestUrl, { params: queryCondition })
      .then((response: any) => {
        const responseData = response.data
        if (responseData.status) {
          throw new Error(responseData['msg'])
        }

        return responseData.data
      })
  }

  CallRequest(requestUrl: string, method: string, condition?: any): Promise<any> {
    const requestParams = condition || {}

    const httpClient = RequestService.Instance().getClient(
      sessionService.getToken()
    )
    return httpClient
      .request({
        method,
        url: requestUrl,
        data: requestParams,
      })
      .then((response: any) => {
        const responseData = response.data
        if (responseData.status) {
          throw new Error(responseData['msg'])
        }

        return responseData.data
      })
  }
}
